module.exports = __webpack_public_path__ + "static/media/chouffe.af2c43ce.jpg";